import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchPolicy, fetchRule } from "./asyncActions";
import { IClubState, IClubDocument } from "./types";

const initialState: IClubState = {
  policy: null,
  rule: null,
  isLoadingPolicy: false,
  isLoadingRule: false,
};

const clubSlice = createSlice({
  name: "club",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Policy
    builder.addCase(fetchPolicy.pending, (state) => {
      state.isLoadingPolicy = true;
    });
    builder.addCase(
      fetchPolicy.fulfilled,
      (state, action: PayloadAction<IClubDocument | null>) => {
        state.isLoadingPolicy = false;
        state.policy = action.payload;
      }
    );
    builder.addCase(fetchPolicy.rejected, (state) => {
      state.isLoadingPolicy = false;
      state.policy = null;
    });

    // Rule
    builder.addCase(fetchRule.pending, (state) => {
      state.isLoadingRule = true;
    });
    builder.addCase(
      fetchRule.fulfilled,
      (state, action: PayloadAction<IClubDocument | null>) => {
        state.isLoadingRule = false;
        state.rule = action.payload;
      }
    );
    builder.addCase(fetchRule.rejected, (state) => {
      state.isLoadingRule = false;
      state.rule = null;
    });
  },
});

export default clubSlice.reducer;

